export const SITE = {
  name: "Postings Inc.",
  tagline: "Bookkeeping • Payroll • Business Support",
  phoneDisplay: "289-464-1001",
  phoneHref: "tel:+12894641001",
  email: "info@postings.cloud",
  address: {
    street: "17665 Leslie Street, Unit 35",
    city: "Newmarket",
    province: "Ontario",
    country: "Canada",
  },
  hours: [
    { days: "Tuesday – Thursday", time: "9:00 AM – 5:00 PM" },
    { days: "Monday & Friday", time: "By Appointment" },
  ],
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=17665+Leslie+Street+Unit+35+Newmarket+Ontario",
  bookingUrl:
    "https://outlook.office365.com/owa/calendar/TheFordGroupProfessionalCorporation@netorg819991.onmicrosoft.com/bookings/",
  regions: "Newmarket • York Region • Northumberland",
  apps: {
    clientManager: {
      name: "Client Manager",
      url: "https://clientmgr.app",
      blurb:
        "A central client access point for working with Postings — send documents, track requests and stay connected with your bookkeeping team in one secure place.",
    },
    postWage: {
      name: "PostWage Payroll",
      url: "https://postwage.app",
      blurb:
        "Postings' own payroll management platform, supporting streamlined payroll processing and payroll information for our clients.",
    },
  },
  paymentUrl: "",
  sisterFirm: {
    name: "Ford & Associates",
    url: "https://fordassociates.ca",
  },
  socials: {
    facebook: "https://www.facebook.com/postingsinc",
    instagram: "https://www.instagram.com/ford_associates/",
    linkedin: "https://www.linkedin.com/company/postings-inc/",
  },
};

export const SERVICES = [
  {
    num: "01",
    icon: "book",
    title: "Bookkeeping",
    blurb:
      "Professional bookkeeping that keeps business records complete, organized and ready when they are needed.",
    items: [
      "QuickBooks Online bookkeeping",
      "Bank & credit-card reconciliations",
      "Transaction categorization",
      "Accounts payable",
      "Accounts receivable",
      "Customer invoicing",
      "Month-end bookkeeping",
      "GST/HST support",
      "Financial reports",
      "Year-end preparation",
      "Inventory & job-costing assistance",
    ],
    cta: { label: "Talk to Us About Bookkeeping", type: "contact" },
  },
  {
    num: "02",
    icon: "users",
    title: "Payroll",
    blurb:
      "Take the administrative burden and compliance worry out of payroll — processed through PostWage Payroll, our own payroll management platform.",
    items: [
      "Employee payroll processing",
      "CPP, EI & income-tax calculations",
      "Vacation pay",
      "CRA payroll remittances",
      "T4 preparation & T4 Summary",
      "Records of Employment",
      "Payroll reconciliations",
      "WSIB-related payroll support",
      "Year-end payroll processing",
    ],
    cta: { label: "Open PostWage", type: "postwage" },
  },
  {
    num: "03",
    icon: "settings",
    title: "QuickBooks & Accounting System Support",
    blurb:
      "We help businesses run on QuickBooks — as a business partner, not just a data-entry service.",
    items: [
      "QuickBooks Online support",
      "New company setup",
      "Account cleanup",
      "Historical bookkeeping cleanup",
      "Chart-of-accounts assistance",
      "System conversion support",
      "Workflow improvement",
      "Bookkeeping troubleshooting",
      "Financial reporting assistance",
    ],
    cta: { label: "Get QuickBooks Support", type: "contact" },
  },
  {
    num: "04",
    icon: "compass",
    title: "Business Support",
    blurb:
      "We help owners understand what their numbers are telling them — and build records their accountant will thank them for.",
    items: [
      "Financial reporting",
      "Job costing",
      "Cost controls",
      "Budgeting",
      "Internal procedures",
      "Business financial organization",
      "Accountant-ready year-end records",
    ],
    cta: { label: "Plan Your Business Support", type: "contact" },
  },
];

export const WHY = [
  {
    icon: "award",
    title: "Experience",
    text: "Years of bookkeeping, payroll, QuickBooks and business financial experience.",
  },
  {
    icon: "phone",
    title: "Responsive Support",
    text: "Real people available when questions arise — you'll always know who to call.",
  },
  {
    icon: "maple",
    title: "Canadian Expertise",
    text: "Focused on Canadian businesses and Canadian payroll and bookkeeping requirements.",
  },
  {
    icon: "cpu",
    title: "Technology + People",
    text: "Modern tools backed by experienced bookkeeping and payroll professionals.",
  },
  {
    icon: "calendar",
    title: "Year-Round Support",
    text: "Not a once-a-year relationship — we're here every month, all year.",
  },
  {
    icon: "folder",
    title: "Accountant Ready",
    text: "Organized books and records that make year-end accounting and tax preparation easier.",
  },
];

export const TEAM = [
  { initials: "MF", name: "Michael Ford", role: "Sr. Accountant / President & CEO", gender: "male" },
  { initials: "DB", name: "Don Bell", role: "Senior Bookkeeper", gender: "male" },
  { initials: "MM", name: "Melissa Marko", role: "Senior Bookkeeper", gender: "female" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Moving our payroll to Postings was the best decision we made this year. Every remittance is on time, T4s just appear, and my crew is always paid correctly — I don't touch a thing.",
    name: "Karen Villiers",
    meta: "Villiers Landscaping, Newmarket, ON",
  },
  {
    quote:
      "Michael and his team were instrumental at helping us navigate a recent HST audit. His expertise, advice and knowledge assisted us to conclude this audit quickly in our favour! We highly recommend Michael and his team to everyone in need of accounting, bookkeeping or QuickBooks services.",
    name: "Stephen Faudemer",
    meta: "Bronto Marketing Group, Sharon, ON",
  },
  {
    quote:
      "Our books were eight months behind when we first called. Postings cleaned everything up, caught up our GST/HST filings and now the monthly reports actually make sense to me.",
    name: "Daniel Okafor",
    meta: "East Ridge Contracting, Aurora, ON",
  },
  {
    quote:
      "Michael is a great help not only with regards to accounting matters but also on how to use this information in QuickBooks. Every time I have a concern regarding these issues he is the one I contact.",
    name: "Vilma Francisco",
    meta: "Sunshine International, Toronto, ON",
  },
  {
    quote:
      "As a QuickBooks rookie I was making a mess of things. Don patiently untangled our accounts and set up a system I can finally follow on my own.",
    name: "Priya Raman",
    meta: "Raman Design Studio, Richmond Hill, ON",
  },
  {
    quote:
      "GST/HST used to keep me up at night. Now it's handled, filed and explained in plain English whenever I have a question. Real people, every single time.",
    name: "Susan Delaney",
    meta: "Delaney's Home Bakery, Cobourg, ON",
  },
];

export const MARQUEE_WORDS = [
  "Bookkeeping",
  "Payroll",
  "QuickBooks Online",
  "GST/HST",
  "T4s & ROEs",
  "CRA Remittances",
  "Reconciliations",
  "Year-End Prep",
];

export const SERVICE_OPTIONS = [
  "Monthly Bookkeeping",
  "Bookkeeping Cleanup",
  "Payroll",
  "QuickBooks Support",
  "GST/HST",
  "Accounts Payable / Receivable",
  "Financial Reporting",
  "Year-End Preparation",
  "Other",
];

export const PROVINCES = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
];

export const EMPLOYEE_RANGES = ["Just me", "1–5", "6–15", "16–50", "50+"];
